import React from 'react'
import PropTypes from 'prop-types'
import OrganisationLogo from './OrganisationLogo'
import LinkedOrganisationLogo from './LinkedOrganisationLogo'

const Organisation = (props) => {
  const linkPrefix = props.linkPrefix
  const featuredCss = 'border border-primary'
  const cardClasses = 'card h-100 text-center card-organisation '
                    + (props.prioritize === true ? featuredCss : '')

  /*
     By default:

     - No link on Orga Logo
     - No link to Orga profile
     - No sponsored badge
     - Empty ratings summary
     - No Catalog button
  */
  let renderedLogo = (
    <OrganisationLogo className='mb-2'
                      logo_url={props.logo_url} shortname={props.shortname} />
  )
  let renderedLink = (<></>)
  let renderedSponsored = (<></>)
  let renderedRatingSummary = (
    <small className='text-body-secondary'>Bisher keine Bewertungen</small>
  )
  let renderedCatalogAction = (
    <button disabled type='button' className='btn btn-link text-decoration-none'>
      momentan keine Kataloge
    </button>
  )

  if (linkPrefix) {
    renderedLogo = (
      <LinkedOrganisationLogo
        slug={props.slug}
        shortname={props.shortname}
        linkPrefix={linkPrefix}
        logo_url={props.logo_url}
        className='mb-2'
      />
    )
    renderedLink = (
      <a
        href={linkPrefix + props.slug}
        title={`${props.shortname} profile`}
        className='organisation-profile-link text-body-secondary text-decoration-none'
      >
        <i className='bi bi-chevron-right'/>{' '}zum Organisationsprofil
      </a>
    )
  }

  if (props.prioritize === true) {
    renderedSponsored = (
      <span className='sponsored small position-absolute top-0 start-0 px-2 text-body-secondary'>gesponsert</span>
    )
  }

  if (props.ratingSummary) {
    const score = props.ratingSummary.score_total.toFixed(2)
    const count = props.ratingSummary.count_ratings

    renderedRatingSummary = (
      <small className='text-body-secondary'>
        ∅{' '}{score} / {count} Bewertungen gesamt
      </small>
    )
  }

  if (props.catalog_enabled) {
    renderedCatalogAction = (
      <button
        onClick={() => {
          props.onOrderClick(props.slug)
        }}
        type='button'
        className='btn btn-outline-primary text-nowrap'
      >
        Gratis Katalog
      </button>
    )
  }

  return (
    <React.Fragment>
      <div className={cardClasses}>
        {renderedSponsored}
        <div className='card-body'>
          {renderedLogo}
          <div
            title={`${props.shortname} profile`}
            className='card-title h4'
          >
            {props.shortname}
          </div>
          {renderedRatingSummary}
        </div>
        <div className='card-footer'>
          <div className='vstack gap-3 align-items-center'>
            {renderedCatalogAction}
            {renderedLink}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

Organisation.propTypes = {
  logo_url: PropTypes.string.isRequired,
  shortname: PropTypes.string.isRequired,
  onOrderClick: PropTypes.func.isRequired,
  linkPrefix: PropTypes.string,
  prioritize: PropTypes.bool,
  ratingSummary: PropTypes.shape({
    count_ratings: PropTypes.number.isRequired,
    score_total: PropTypes.number.isRequired,
  }),
}

export default Organisation
